import ajax from '../../../../components/ajax';
import _ from 'lodash';
import { ProgramMenu } from './ProgramMenu';
import { ProgramSection } from './ProgramSection';
import * as styles from './workouts.css';

type ProgramPageProps = {
  refreshWorkouts: () => void;
  params: {
    programId?: string;
  };
  influencer: {
    customizations: {
      hideLibrary: boolean;
    };
    customURL: string;
  };
  influencerId: number;
  programs: any[];
  workoutsLoading?: boolean;
};

export const ProgramPage = (props: ProgramPageProps) => {
  const paramsProgramId =
    props.params.programId !== undefined
      ? parseInt(props.params.programId)
      : null;

  const currentProgramId =
    paramsProgramId !== null
      ? paramsProgramId
      : props.programs?.length
      ? props.programs[0].id
      : null;

  const onChange = () => {
    props.refreshWorkouts();
  };

  // Rejects on failure so the list can roll back to the pre-drop order.
  const onReorder = (programId: number, workoutIds: number[]) =>
    ajax
      .reorderProgram(programId, workoutIds)
      .then(() => {
        props.refreshWorkouts();
      })
      .catch((e) => {
        console.error('[WorkoutList] Error performing Program reorder.', e);
        throw e;
      });

  const { influencer, programs } = props;
  const selectedProgram = programs.find((p) => p.id == currentProgramId);
  return (
    <div className={styles.programPage}>
      <ProgramMenu
        creatorId={props.influencerId}
        programs={programs}
        selectedProgramId={currentProgramId}
      />
      {props.workoutsLoading ? (
        <div>Loading...</div>
      ) : (
        Boolean(selectedProgram) && (
          <ProgramSection
            influencerId={props.influencerId}
            influencer={influencer}
            key={selectedProgram?.id}
            program={selectedProgram}
            onReorder={onReorder}
            onChange={onChange}
          />
        )
      )}
    </div>
  );
};
